// CustomLoaderProvider.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import { CircularProgress, Backdrop } from "@mui/material";

const LoaderContext = createContext((value : any) => {});

export const useCustomLoader = () => useContext(LoaderContext);

const CustomLoaderProvider = ({ children } :any) => {
  const [loading, setLoading] = useState(false);

  // one function to toggle loader
  const setLoader = useCallback((value :any) => {
    setLoading(value);
  }, []);

  return (
    <LoaderContext.Provider value={setLoader}>
      {children}

      {/* Loader UI */}
      <Backdrop
        open={loading}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" size={200} />
      </Backdrop>
    </LoaderContext.Provider>
  );
};

export default CustomLoaderProvider;
